import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Generativeaimodels() {
  return (
    <section
      className="generative_ai_models p-100"
      style={{ background: "#F9F9F9" }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={9}
            lg={8}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>
              Our Generative AI Models <span>Expertise</span>
            </h2>
          </Col>
        </Row>
        <Row className="mt-sm-3 mt-md-4">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="text-center">
            <StaticImage
              src="../../images/services-usa/generative-ai/generative_models.webp"
              alt="tekrevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={2822}
              height={1624}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Generativeaimodels;
